import res from './res'

res.add('kk', {
    paymentsAmount: 'Аудармалар сомасы',
    paymentsCount: 'Аудармалар саны'
})
